package util

import kotlinx.browser.window

object ScrollHelper {
    /**
     * Returns the scroll progress in viewport height units.
     *
     * @return a double value greater than or equal to 0.0
     */
    fun getScrollProgress(): Double = (window.scrollY / window.innerHeight.toDouble()).coerceAtLeast(0.0)
}